import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import cx from "classnames";
import { fetchAdminAppUsers } from "actions/users";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import { Container } from "semantic-ui-react";
import { ToastContainer } from "react-toastify";

import SigninPage from "../anonymous/signin";
import AuthService from "services/auth.service";

import Navbar from "components/features/Navbar";
import Accounts from "pages/accounts";
import AccountDetail from "pages/accountDetail";

import styles from "./application.module.scss";
import { useSelector } from "react-redux";
import ScrollToTop from "components/ui/ScrollToTop/ScrollToTop";
import Dashboard from "pages/dashboard";
import UsageMetrics from "pages/usageMetrics";

export default function Application(props) {
  return (
    <Router>
      <ScrollToTop>
        <Switch>
          <Route exact path="/login">
            <SigninPage />
          </Route>

          <Route path="/logout">
            <SigninPage />
          </Route>

          <ProtectedRoute>
            <ApplicationLoader>{renderContent()}</ApplicationLoader>
          </ProtectedRoute>
        </Switch>
      </ScrollToTop>
    </Router>
  );
}

function ProtectedRoute({ children, ...rest }) {
  var authenticated = AuthService.isAuthenticated();
  return (
    <Route
      {...rest}
      render={() =>
        authenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
            }}
          />
        )
      }
    />
  );
}

function renderContent() {
  return (
    <Container fluid className={cx(styles.application)}>

      <Navbar isUserDetail={true} />

      <Route exact path="/:product/accounts">
        <Accounts />
      </Route>

      <Route path="/:product/dashboard">
        <Dashboard />
      </Route>

      <Route path="/:product/metrics">
        <UsageMetrics />
      </Route>

      <Switch>
        <Redirect exact from="/" to="/paperflite/accounts" />

        <Route path="/:product/accounts/:id">
          <AccountDetail />
        </Route>
      </Switch>

      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Container>
  );
}

function ApplicationLoader(props) {
  const dispatch = useDispatch();
  dispatch(fetchAdminAppUsers());

  return props.children;
}
